import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";

const PaymentDetails = ({ paymentType, cardInfo, frequency, paymentDate }) => {
  const { t } = useTranslation(NAME_SPACES.COMPONENTS);
  const PAYMENT_DETAILS = t("PAYMENT_DETAILS", { returnObjects: true });
  const { cardNumber, expiryDate, cvv } = cardInfo;

  return (
    <div className="payment__details">
      <div className="payment__details--section">
        <h3 className="key">{PAYMENT_DETAILS.PAYMENT_TYPE}</h3>
        <p className="value">{paymentType}</p>
      </div>

      <div className="payment__details--section">
        <h3 className="key">{PAYMENT_DETAILS.CARD_INFO}</h3>
        <p className="value">
          <small>{PAYMENT_DETAILS.CARD_NUMBER}:</small>{" "}
          <span>{cardNumber}</span>
        </p>
        <p className="value">
          <small>{PAYMENT_DETAILS.EXPIRY_DATE}:</small>{" "}
          <span>{expiryDate}</span>
        </p>
        <p className="value">
          <small>{PAYMENT_DETAILS.CVV}:</small> <span>{cvv}</span>
        </p>
      </div>

      <div className="payment__details--section">
        <h3 className="key">{PAYMENT_DETAILS.FREQUENCY}</h3>
        <p className="value">{frequency}</p>
      </div>

      <div className="payment__details--section">
        <h3 className="key">{PAYMENT_DETAILS.PAYMENT_DATE}</h3>
        <p className="value">{paymentDate}</p>
      </div>
    </div>
  );
};

PaymentDetails.propTypes = {
  paymentType: PropTypes.string.isRequired,
  cardInfo: PropTypes.shape({
    cardNumber: PropTypes.string.isRequired,
    expiryDate: PropTypes.string.isRequired,
    cvv: PropTypes.string.isRequired,
  }).isRequired,
  frequency: PropTypes.string.isRequired,
  paymentDate: PropTypes.string.isRequired,
};

export default PaymentDetails;
